export interface BondsInfoDto {
  nativePrice: string;
  bondFundWalletUsd: string;
  currentNftPriceNative: string;
  FUND_WALLET: string;
  isNftPriceValid: boolean;
}

export interface SignMintDto {
  params: {
    amountNfts: number;
    deadline: number;
    nonce: string;
    paymentAmount: string;
    receiver: string;
    uuid: string;
  };
  signature: string;
}

export interface SignRedeemDto {
  params: {
    amountNfts: number;
    deadline: number;
    nonce: string;
    seller: string;
    totalSellPrice: string;
    uuid: string;
  };
  signature: string;
}

export interface BondsTotalRewardsDistributedDto {
  amountUsd: string;
}

export enum BondsAction {
  Mint = 'mint',
  Transfer = 'transfer_by_operator',
}

export interface BondsActionHistoryDto {
  action: BondsAction;
  datetime: string;
  id: number;
  nftsAmount: string;
  paymentAmountNative: string;
  paymentAmountUsd: string;
  txHash: string;
}

export interface BondsPerformanceMetricsDto {
  netDeposits: string;
  totalProfits: string;
}
